import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import axios from "axios";
import "leaflet/dist/leaflet.css";
import StatIcon from "../../../assets/icons/staticon.svg";
import { Icon } from "leaflet";
import { ScreenWrapper } from "../../complexes/ScreenWrapper";
import styles from "./Map.module.scss";
import { BACK_PRODUCTION } from "../../../constants/constants";

interface Station {
  id: number;
  name: string;
  address: string;
  coords: string;
  lat: string;
  lon: string;
  yandex_id: string;
  work_period: string[];
  car_price: string;
  balloon_price: string;
}

const MapComponent: React.FC = () => {
  const [stations, setStations] = useState<Station[]>([]);
  const [selectedStationId, setSelectedStationId] = useState<number | null>(
    null
  );

  useEffect(() => {
    const fetchStations = async () => {
      try {
        const response = await axios.get(
          `${BACK_PRODUCTION}/api/v1/legal/stations`  // TODO потом сделать лучше
        );
        setStations(response.data.data);
      } catch (error) {
        console.error("Error fetching stations:", error);
      }
    };

    fetchStations();
  }, []);

  const legalIcon = new Icon({
    iconUrl: StatIcon,
    iconSize: [35, 35],
    iconAnchor: [17, 17],
    popupAnchor: [-3, -76],
  });

  return (
    <ScreenWrapper
      title={"Адреса наших АГЗС"}
      classes={{ content: styles.container }}
    >
      <MapContainer
        attributionControl={false}
        center={[56.833332, 60.583332]}
        zoom={10}
        className={styles.inner}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {stations.map((station, i) => {
          return !!station.lat && !!station.lon ? (
            <Marker
              key={station.id}
              position={[parseFloat(station.lat), parseFloat(station.lon)]}
              eventHandlers={{
                click: () => setSelectedStationId(station.id),
              }}
              icon={legalIcon}
            >
              {selectedStationId === station.id && (
                <Popup>
                  <div>
                    <h2>{station.name}</h2>
                    <p>
                      <strong>Адрес:</strong> {station.address}
                    </p>
                    <p>
                      <strong>Время работы:</strong> {station.work_period.join(',')}
                    </p>
                    <p>
                      <strong>Стоимость литра газа:</strong> {station.car_price}{" "}
                      руб.
                    </p>
                    <p>
                      <strong>Стоимость литра баллона:</strong>{" "}
                      {station.balloon_price} руб.
                    </p>
                  </div>
                </Popup>
              )}
            </Marker>
          ) : (
            <React.Fragment key={station.id}></React.Fragment>
          );
        })}
      </MapContainer>
    </ScreenWrapper>
  );
};

export default MapComponent;
